import request from '@/utils/request'
const api = {
    GetOpenList:'/Portal/GetOpenList',
    GetIntegrityList:'/Portal/GetIntegrityList',
    GetOtherList:'/Portal/GetOtherList',
    GetBulletinContent:'/Portal/GetBulletinContent',
    GetBulletin:'/Portal/GetBulletin',
    GetNewsContent:'/Portal/GetNewsContent',
    GetSearchInfo:'/Portal/GetSearchInfo',
    AddOpinion:'/Portal/AddOpinion'
}
export function GetOpenList(param) {
    return request({
        url: api.GetOpenList,
        method: 'post',
        data: param,

    })
}

export function GetIntegrityList(param) {
    return request({
        url: api.GetIntegrityList,
        method: 'post',
        data: param,

    })
}

export function GetOtherList(param) {
    return request({
        url: api.GetOtherList,
        method: 'post',
        data: param,

    })
}

export function GetBulletinContent(param) {
    return request({
        url: api.GetBulletinContent,
        method: 'post',
        data: param,

    })
}

export function GetBulletin(PrjId) {
    return request({
        url: api.GetBulletin+'?PrjId='+PrjId,
        method: 'post',

    })
}

export function GetNewsContent(news_id) {
    return request({
        url: api.GetNewsContent+"?news_id="+news_id,
        method: 'post',
    })
}
export function GetSearchInfo(param) {
    return request({
        url: api.GetSearchInfo,
        method: 'post',
        data: param,

    })
}
export function AddOpinion(param) {
    return request({
        url: api.AddOpinion,
        method: 'post',
        data: param,

    })
}
